import React, { useState } from 'react';
import { useParams } from 'react-router-dom'; 
import { Helmet, HelmetProvider } from 'react-helmet-async';
import BlogPostDetail from '../components/BlogPostDetail'; 
import "../styles/_blog.css";

function BlogPostPage() {
  const { slug } = useParams(); 
  
  // 1. State to hold the dynamic title fetched from the child component
  const [postTitle, setPostTitle] = useState(null); 
  
  // 2. Calculate the page title based on the state. 
const pageTitle = postTitle 
  ? `${postTitle} | Brand Acumen` // <-- Uses the title passed up
  : 'Blog Post | Brand Acumen'; 
    
  // 3. Define the handler function to be passed to the child
  const handlePostLoaded = (title) => {
    // Update the state with the title received from the detail component
    setPostTitle(title);
  };
    
  return (
    <>
      <HelmetProvider>
        <Helmet>
          {/* 4. Use the dynamic pageTitle here */}
          <title>{pageTitle}</title>
          <meta name="description" content="Read a detailed blog post from Brand Acumen." />
        </Helmet>
      </HelmetProvider>
      
      {/* 5. Pass the callback function to the detail component */}
      <BlogPostDetail 
          postSlug={slug} 
          onPostLoaded={handlePostLoaded} 
      /> 
    </>
  );
}

export default BlogPostPage;
